import { useEffect } from "react"
import { useMe } from "./selectors"
import { i18n } from "@/i18n"

/**
 * In the authenticated app the user's stored locale is the source of truth, so
 * apply it once their profile loads. (Public pages take their locale from the
 * URL / the switcher instead.)
 */
export default function useSyncUserLocale() {
  const { data: me } = useMe()
  const locale = me?.locale

  useEffect(() => {
    if (locale && i18n.language !== locale) {
      void i18n.changeLanguage(locale)
    }
  }, [locale])
}
